// removed by extract-text-webpack-plugin
module.exports = {"bcLink":"src-components-Button-___BackArrow__bcLink___zQvt2","label":"src-components-Button-___BackArrow__label___2glLI","backArrow":"src-components-Button-___BackArrow__backArrow___eEVjm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/BackArrow.css
// module id = 883
// module chunks = 3